import { Card } from 'components/card/card'
import React, { useState } from 'react'
import { Box, Flex, FormLabel, Stack } from '@chakra-ui/react'
import { TicketFilters } from 'features/ticket-page/grid/ticket-filters'
import { useStickyState } from 'utils/hooks'
import { TicketsTable } from 'features/ticket-page/tickets-table'

const TicketsPage: React.FC = () => {
  const [, setResetAllFilters] = useState(false)
  const [selectedCard, setSelectedCard] = useStickyState(null, 'project.selectedCard')

  const clearAll = () => {
    setResetAllFilters(true)
    setTimeout(() => {
      setResetAllFilters(false)
    }, 700)
    setSelectedCard('')
  }

  return (
    <>
      <Stack>
        <Box w="100%" mb="5px">
          <TicketFilters
            clear={clearAll}
            onSelectCard={selection => {
              setSelectedCard(selection)
            }}
            selectedCard={selectedCard}
            selectedFPM={null}
          />
        </Box>
        <Card
          w="100%"
          py="14px"
          px="14px"
          boxShadow="0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)"
        >
          <Flex w="100%" mb="14px" alignItems={'center'}>
            <FormLabel variant="strong-label" size="lg" whiteSpace="nowrap" m="0" fontSize="18px">
              Tickets
            </FormLabel>
          </Flex>

          <Box w="100%" minH="450px">
            <TicketsTable selectedCard={selectedCard} />
          </Box>
        </Card>
      </Stack>
    </>
  )
}

export default TicketsPage
